/**
 * BP-13 §9's `photos.*` strings.
 *
 * A flat object, the shape `features/colour` and `features/licensing` use;
 * BP-19 is the BP that adds Hindi, Marathi and Gujarati and moves every
 * feature's strings at once.
 *
 * **The no-consent state is a sentence, not a disabled button.** A technician
 * who sees a greyed-out camera assumes the app is broken; one who reads
 * "Asha has not agreed to photos being kept" knows what to do about it. That
 * is the single most important string in this file.
 */
export const strings = {
  title: 'Photos',
  empty: 'No photos of this set yet.',
  loading: 'Loading photos…',
  failed: 'The photos could not be loaded.',

  noConsent: 'This client has not agreed to photos being kept.',
  noConsentHint: 'Ask at the desk and record it under their consents, then come back.',

  atCapacity: 'This set already has {{count}} photos, which is the most it may hold.',
  atCapacityHint: 'Delete one you do not need before taking another.',

  kind_before: 'Before',
  kind_after: 'After',
  kind_detail: 'Detail',

  capture: 'Add a photo',
  capturing: 'Uploading…',
  captureFailed: 'That photo was not accepted.',
  remove: 'Delete',
  removeConfirm: 'Delete this photo? The image is removed for good.',

  deleted: 'Deleted',
  deletedHint: 'The image was removed. The record of it stays.',
  takenOn: 'Taken {{when}}',
  keptUntil: 'Kept until {{when}}',

  share: 'Share',
  shareTitle: 'Nails by 26AD',
  shareUnavailable: 'This device has no share sheet.',
  notShareable: 'This client has not agreed to their photos being shared.',

  myTitle: 'My photos',
  myEmpty: 'No photos yet.',
  myEmptyHint: 'Your technician can add them during a visit, if you agree to it.',
} as const;
